export default __webpack_public_path__ + "static/media/Group 5559.8d0692c6.svg";